export class ComboOfBenefitsIssue{
    isCobIssue: boolean = false;
    cobIssueStatus: string = '';
}